import React, { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import config from "@config/sortConfig";
import { IconSortDown, IconSortUp } from "@searchComponents/icons";
import { translations } from "@utils/translations";
import removeSortHash from "@utils/removeSortHash";
import { useHistory } from "react-router-dom";
import { setFilter } from "../store/actions";
import styles from "../../../styles/components/sort.module.scss";

const SearchSort = memo(({ filter }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [order, setOrder] = useState();
    const [value, setValue] = useState();
    const appSettings = useSelector(({ rootReducer }) => rootReducer.baseSettings);
    const data = useSelector(({ searchReducer }) => searchReducer.searchPostsData.data);
    const lang = appSettings.searchLanguage ? appSettings.searchLanguage : "en";
    const carConfigObject = config.find((item) => item.type === "car");
    const artConfigObject = config.find((item) => item.type === "art");

    let sortConfig = carConfigObject ? carConfigObject.config : null;
    if (appSettings.searchPostType === "museum_art") {
        sortConfig = artConfigObject ? artConfigObject.config : null;
    }

    const setOrderDirection = () => {
        const newOrder = order.order === "ASC" ? "DESC" : "ASC";

        setOrder((o) => ({ ...o, order: newOrder }));

        dispatch(setFilter(`order=${newOrder}&orderby=${order.orderBy}&meta_key=${order.metaKey}${removeSortHash(filter)}&value=${order.value}`));
    };

    // selectorStyles object
    const customStyles = {
        option: (styles, state) => ({
            ...styles,
            cursor: "pointer",
        }),
        control: (styles) => ({
            ...styles,
            cursor: "pointer",
        }),
    };

    // eslint-disable-next-line no-unused-vars
    const translate = (s) => translations[lang][s] ?? s;

    const formatOptionLabel = ({ label }) => (
        <span>
        {translate(label)}
      </span>
    );

    useEffect(() => {
        if (!filter) return;
        setOrder({
            order: new URLSearchParams(filter).get("order"),
            orderBy: new URLSearchParams(filter).get("orderby"),
            metaKey: new URLSearchParams(filter).get("meta_key"),
            value: new URLSearchParams(filter).get("value"),
        });
    }, [filter]);

    return (
        <div className={styles.container}>
            <Select
                styles={`${customStyles}`}
                classNamePrefix="react-select"
                formatOptionLabel={formatOptionLabel}
                options={sortConfig.sort((a, b) => +b.isDefault - +a.isDefault).filter(({ isDefault }) => isDefault).map(({
                                                                                                                              value,
                                                                                                                              label,
                                                                                                                          }, index) => ({
                    value,
                    label,
                    sortIndex: index,
                }))}
                placeholder={translate("orderBy")}
                isClearable={true}
                isSearchable={false}
                className={`${styles.sorting} `}
                value={{
                    value: sortConfig.find((data) => data.value === order?.field)?.value,
                    label: translate(sortConfig.find((data) => data.value === order?.value)?.label),
                }}
                onChange={(nextValue) => {
                    dispatch(setFilter(`order=${sortConfig[nextValue?.sortIndex].order}&orderby=${sortConfig[nextValue?.sortIndex].orderBy}&meta_key=${sortConfig[nextValue?.sortIndex].metaKey}&value=${sortConfig[nextValue?.sortIndex].value}${removeSortHash(filter)}`));
                }}
            />
            <div
                className={`${styles.direction} `}
                onClick={setOrderDirection}
                onKeyDown={(e) => {
                    if (["Enter", "Space"].includes(e.code)) {
                        e.preventDefault();
                        setOrderDirection();
                    }
                }}
                tabIndex={0}
            >
                {order?.order === "DESC"
                    ? <IconSortDown/>
                    : <IconSortUp/>
                }
            </div>
        </div>
    );
});

export default SearchSort;
